import { render, staticRenderFns } from "./PortalFileInput.vue?vue&type=template&id=027f8376&scoped=true&"
import script from "./PortalFileInput.vue?vue&type=script&lang=js&"
export * from "./PortalFileInput.vue?vue&type=script&lang=js&"
import style0 from "./PortalFileInput.vue?vue&type=style&index=0&id=027f8376&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027f8376",
  null
  
)

export default component.exports